// Module
var code = "<div class=\"basket-engraving-validation-message\" data-error-type=\"{{type}}\">{{message}}</div>";
// Exports
module.exports = code;